import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import authenticatedUser from './authenticated-user.store';
import { listenerMiddleware } from './middleware';

const authenticationState = JSON.parse(localStorage.getItem('user') || 'null');

const reducer = combineReducers({
    authenticatedUser,
});

const store = configureStore({
    preloadedState: {
        authenticatedUser: authenticationState,
    },
    reducer,
    middleware: (getDefaultMiddleware) => [...getDefaultMiddleware(), listenerMiddleware.middleware],
});

export default store;
